
export default {
  name: 'OrganismContactForm',
  props: {
    disableCompanyNumber: {
      required: false,
      type: Boolean,
      default: false
    },
    disableCompanyAddress: {
      required: false,
      type: Boolean,
      default: false
    },
    titleContactForm: {
      required: false,
      type: [String, Object],
      default: ""
    },
    subtitleContactForm: {
      required: false,
      type: [String, Object],
      default: ""
    }
  },
}
